import {SETUP_AGENT_STORAGE_PREFIX} from '../../promptToCardAgentV2.consts';

export default function deleteCardFromState() {
  sessionStorage.removeItem(SETUP_AGENT_STORAGE_PREFIX);
}
